<template>
    <div id="clouds" v-if="loaded">
        <div v-for="(cloud, index) in clouds" :key="cloud+index">
            <div class="cloud" v-html="cloud" :id="ids[index]">
            </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import eventBus from "../eventBus";

export default {
    name: 'clouds',
    data() {    
        return {
            loaded: false,
            cloudData: [],
            clouds: [],
            ids: []
        }
    },
   created() {
        this.fetchData(() => {
            this.colors = window.colors;
            this.loaded = true;
        });
        eventBus.$on("createCloud", this.createCloud);
   },
   beforeDestroy() {
        eventBus.$off("createCloud", this.createCloud);
   },
   methods: {
        fetchData(callback) {
            var requests = [];
            requests.push(axios.get(window.dataPath + "image/bonbons/cloud.svg"));
            requests.push(axios.get(window.dataPath + "image/bonbons/cloud2.svg"));

            axios.all(requests).then(axios.spread((cloudA, cloudB) => {
                this.cloudData.push(cloudA.data);
                this.cloudData.push(cloudB.data);
                if (callback) callback();
            })).catch(error => console.log(error));
       },
       createCloud() {
            if (this.clouds.length >= 2) return;
            for (var i = 0; i < 2; i++) {
                var id = 'clouds' + this.createID();
                this.ids.push(id);
                this.clouds.push(this.cloudData[i])
            }
            this.$nextTick(() => {
                for (var i = 0; i < this.ids.length; i++) {         
                    var offset = i < 1 ? [615, 75] : [1115, 255];
                    var dest = i < 1 ? [0, -50] : [50, 0];
                    var duration = 1500;
                    var element = document.getElementById('clouds').querySelector('#' + this.ids[i]);
                    Velocity(element, { translateX: offset[0] - (50 * 0.5), translateY: offset[1] - (50 * 0.5) }, { duration: 0 });
                    Velocity(element, { translateX: "+=" + dest[0], translateY: "+=" + dest[1] }, { duration: duration, queue: false, easing: "easeOutSine" });
                    Velocity(element, { opacity: 1 }, { duration: duration * 0.2 });
                    Velocity(element, { opacity: 0 }, { duration: duration * 0.8, delay: duration * 0.2, easing: "easeOutSine", 
                        complete: () => { 
                            this.ids.shift();
                            this.clouds.shift();
                        } 
                    });
            
                }
            });
        }, 
        /**
         * Generate unique IDs for use as pseudo-private/protected names.
         * Similar in concept to
         * <http://wiki.ecmascript.org/doku.php?id=strawman:names>.
         */
        createID() {
            return '_' + Math.random().toString(36).substr(2, 9);
        }
   }
}
</script>

<style lang="scss">
#clouds {
    position: absolute;
    width: 100%;
    height: 100%;

    .cloud {
        position: absolute;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/Clouds.vue